import React, { Component } from 'react';
import './HootsuiteLogo.css';

class HootsuiteLogo extends Component {
    render() {
        return (
            <div className="project-page">
                <h3 className="project-date">June 2017</h3>
                <h1 className="project-title">Flapping Owl</h1>
                <p className="project-description">Flapping Owl is an animated Hootsuite logo created
                using HTML and CSS. I created this project to celebrate my excitment for landing <a href="http://code.hootsuite.com/co-ops/joy-zhang/">my first internship
                at Hootsuite.</a> Also checkout my blog post on <a href="http://code.hootsuite.com/using-protocol-buffer-to-generate-sdk-at-hoosuite/">How to Use Protobug to Generate SDK at Hootsuite.</a> </p>
                <p className="project-description">Hover over the ears and body of the owl to see it move!</p>
                <a className="project-url" href="https://github.com/joy8zhang/hootsuite-logo">Github</a>
                <div className="hootsuite-logo">
                    <div className = "head">
                      <div className = "l_ear"></div>
                      <div className = "r_ear"></div>
                      <div className = "l_eye"></div>
                      <div className = "r_eye"></div>
                      <div className = "l_eyeball"></div>
                      <div className = "r_eyeball"></div>
                      <div className = "l_eyecenter"></div>
                      <div className = "r_eyecenter"></div>
                      <div className = "beak"></div>
                    </div>
                    <div className = "body">
                      <div className = "r_wing"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default HootsuiteLogo;



// WEBPACK FOOTER //
// ./src/projects/HootsuiteLogo.js